/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A blue base with the triadic rule gives blue, green and red.`)
};

const es_cp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un color base azul con la regla triádica da azul, verde y rojo.`)
};

const de_cp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine blaue Basisfarbe ergibt mit der triadischen Regel Blau, Grün und Rot.`)
};

const nl_cp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een blauwe basiskleur met de triadische regel geeft blauw, groen en rood.`)
};

const fr_cp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une base bleue avec la règle triadique donne bleu, vert et rouge.`)
};

const it_cp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un blu di base con la regola triadica dà blu, verde e rosso.`)
};

const pt_br2_cp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma cor base azul com a regra da tríade dá azul, verde e vermelho.`)
};

const pt_cp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma cor base azul com a regra triádica dá azul, verde e vermelho.`)
};

const ja_cp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`青をベースにトライアドルールを適用すると、青・緑・赤の配色になります。`)
};

const zh_cp_ex1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以蓝色为基础色，采用三分色规则，可得到蓝、绿、红三色。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_ex1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_ex1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_ex1", locale)
	if (locale === "en") return en_cp_ex1(inputs)
	if (locale === "es") return es_cp_ex1(inputs)
	if (locale === "de") return de_cp_ex1(inputs)
	if (locale === "nl") return nl_cp_ex1(inputs)
	if (locale === "fr") return fr_cp_ex1(inputs)
	if (locale === "it") return it_cp_ex1(inputs)
	if (locale === "pt-BR") return pt_br2_cp_ex1(inputs)
	if (locale === "pt") return pt_cp_ex1(inputs)
	if (locale === "ja") return ja_cp_ex1(inputs)
	return zh_cp_ex1(inputs)
};